"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Tags = _interopRequireDefault(require("./Tags.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Tags = _ref => {
  let {
    classNames,
    tags
  } = _ref;
  const css = (0, _Tags.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classNames, css.tags, "mco-shop-tags")
  }, tags === null || tags === void 0 ? void 0 : tags.map((_ref2, index) => {
    let {
      color = "default",
      title
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: (0, _clsx.default)(css.tag, "mco-shop-tags__tag", {
        [css === null || css === void 0 ? void 0 : css[color]]: color,
        ["mco-shop-tags__tag--".concat(color)]: color
      }),
      key: index
    }, title);
  }));
};
var _default = exports.default = Tags;